import ExtensionService from 'live/services/extension'
import Form from './integration/form'
import AssetSetupForm from './tabs/AssetSetup/AssetSetupForm'
import ServiceLocator from 'live/services/service-locator'
import { canViewAssetSetup } from './permission/Permissions'

const extension = {
    name: 'Asset Setup',
    type: 'asset-setup',
    origin: 'Live Asset Setup',
    roles: [],
    icon: '/content/plugin-asset-setup/icon.png',
    ui: {
        form: Form,
        view: null
    }
}

ExtensionService.register(extension)

if (canViewAssetSetup()) {
    try {
        ServiceLocator.getService('asset-tab-service').then(service => {
            // @ts-ignore
            service.register({
                step: `asset-setup`,
                assetType: `wells`,
                label: 'Asset Setup',
                shouldHide: false,
                body: AssetSetupForm
            })
        })
    } catch (e) {
        console.error(e)
    }
}
